import { SeriesItemData } from '../../../../../components/blackrock/advisor-center/cards/series-item-card/SeriesItemCardProps';

export const getRelevantAuthors = (
	authors: string[],
	items: SeriesItemData[]
): string[] =>
	authors.filter((author) =>
		items.some(({ authors }) => {
			const listOfAuthors = authors.map(({ authorName }) => authorName);
			return listOfAuthors.includes(author);
		})
	);

export const getRelevantTopics = (items: SeriesItemData[]): string[] => {
	let topicSet: Set<string> = new Set();
	items.forEach((i) => {
		if (i.topics) {
			topicSet = new Set([...topicSet, ...i.topics]);
		}
	});
	return [...topicSet];
};

export const getRelevantPublications = (items: SeriesItemData[]): string[] => {
	let publicationSet: Set<string> = new Set();
	items.forEach((i) => {
		if (i.publications) {
			publicationSet = new Set([...publicationSet, ...i.publications]);
		}
	});
	return [...publicationSet];
};
